import { useState, useEffect } from 'react';
import { message } from 'antd';
import apiService from '../services/api';

export const useChannels = ({ activeOnly = false } = {}) => {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = activeOnly
      ? apiService.channels.getActive
      : apiService.channels.getAll;
    fetch()
      .then(res => setChannels(res.data || []))
      .catch(() => message.error('Failed to load channels'))
      .finally(() => setLoading(false));
  }, [activeOnly]);

  return { channels, loading };
};
